import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, Text, Image } from 'rebass';
import jobsIcon from 'assets/icons/jobs.png';
import createJobPosting from 'assets/icons/createJobPosting.png';
import candidatesImg from 'assets/icons/candidates.png';
import Link from 'components/Link';
import colors from 'theme/colors';
import { EMPLOYERS } from '../content';
import Notifications from './Notifications';
import BlockWrapper from './BlockWrapper';
import useWaitForLeavingDashboard from '../hooks/useWaitForLeavingDashboard';

// Components
import DashBoardStatisticItem from './DashBoardStatisticItem';

const EmployerDashBoard: React.FC = (): JSX.Element => {
  useWaitForLeavingDashboard();
  const { jobs, candidates } = useSelector<any, any>(state => state.statistics);

  return (
    <Flex width="100%" flexDirection="column">
      <Notifications content={EMPLOYERS} />
      <Flex justifyContent="space-between">
        <BlockWrapper width="calc(50% - 15px)">
          <Flex>
            <Flex alignItems="flex-start">
              <Image src={jobsIcon} />
            </Flex>
            <Flex flexDirection="column" ml={1}>
              <Text fontSize="25px" fontWeight={6} lineHeight={1} mb={3}>
                {EMPLOYERS.jobPostings.title}
              </Text>
              {!jobs.active && !jobs.nonPublished && (
                <>
                  <Text fontSize="20px" fontWeight={5} lineHeight={1.5} mb={4}>
                    {EMPLOYERS.jobPostings.subtitle}
                  </Text>
                  <Flex alignItems="center">
                    <Image src={createJobPosting} />
                    <Link
                      to="/create-job-post"
                      color={colors.green}
                      hover={colors.green}
                      fontSize="18px"
                      ml={1}
                      css="font-weight: 600"
                    >
                      {EMPLOYERS.jobPostings.createLink}
                    </Link>
                  </Flex>
                </>
              )}
              {!!jobs.active && (
                <DashBoardStatisticItem to="/job-posts">
                  {jobs.active} active
                </DashBoardStatisticItem>
              )}
              {!!jobs.actnonPublishedive && (
                <DashBoardStatisticItem>{jobs.nonPublished} archived</DashBoardStatisticItem>
              )}
            </Flex>
          </Flex>
        </BlockWrapper>
        <BlockWrapper width="calc(50% - 15px)" flexDirection="column">
          <Flex>
            <Flex alignItems="flex-start">
              <Image src={candidatesImg} />
            </Flex>
            <Flex flexDirection="column" ml={1}>
              <Text fontSize="25px" fontWeight={6} lineHeight={1} mb={3}>
                {EMPLOYERS.applicants.title}
              </Text>
              {!candidates.total && (
                <>
                  <Text fontSize="20px" fontWeight={5} lineHeight={1.5} mb={4}>
                    {EMPLOYERS.applicants.subtitle}
                  </Text>
                  <Flex width="100%" justifyContent="space-between" css="max-width: 380px;" />
                </>
              )}
              {!!candidates.total && (
                <DashBoardStatisticItem>
                  {candidates.total} applications in total
                </DashBoardStatisticItem>
              )}
              {!!candidates.pending && (
                <DashBoardStatisticItem>{candidates.pending} pending</DashBoardStatisticItem>
              )}
              {!!candidates.rejected && (
                <DashBoardStatisticItem>{candidates.rejected} rejected</DashBoardStatisticItem>
              )}
            </Flex>
          </Flex>
        </BlockWrapper>
      </Flex>
    </Flex>
  );
};

export default EmployerDashBoard;
